export function parseUndefinedDef() {
    return {
        not: {},
    };
}
